<tt-page *ngIf="!!page">
    <tt-page-heading *ngIf="!!page.page_heading" [ttModel]="page.page_heading"></tt-page-heading>
    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
